import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAccount } from "../Account";
import { useGlobalConfig } from "../GlobalConfig";
import {
  clearAccountData,
  clearSearchHistory,
} from "../../util/clearSensitiveSessionData";
import { axios } from "../AxiosInstanceManager";
import { useErrorDialog } from "@tlc/ui/dialog/error/ErrorDialogContext";

export function useLogout() {
  const { user } = useAccount();
  const { adfsSettings } = useGlobalConfig();
  const navigate = useNavigate();
  const { handleRequestError } = useErrorDialog();

  const logout = React.useCallback(async (redirectTo: string = "/") => {
    if (adfsSettings.enabled && user.local === false) {
      window.location.href = adfsSettings.logoutUrl;
      return;
    }

    try {
      await axios.get(`/logout`);
    } catch (error: unknown) {
      console.error("An unexpected error occurred during logout:", error);
      handleRequestError(error);
    }
    navigate("/");
    // wait for tansition in case we are using the hook inside a my account page
    queueMicrotask(() => {
      clearAccountData();
      clearSearchHistory();
    });
    return;
  }, []);

  return logout;
}

export const LogoutPage: React.FC = () => {
  const logout = useLogout();

  React.useEffect(() => {
    if (logout) {
      logout();
    }
  }, [logout]);

  return <></>;
};
